import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Открыть тарифы роут-модалом поверх текущей страницы (канонический паттерн
 * React Router: фон передаётся в location.state.backgroundLocation в момент
 * навигации — App читает его и рендерит подложку под оверлеем). Прямой заход
 * по URL/refresh состояния не имеет → /tariffs открывается полной страницей.
 *
 * @param search — опциональный query, напр. '?credits=500' для deep-link.
 */
export function useOpenTariffs() {
	const navigate = useNavigate()
	const location = useLocation()
	return useCallback(
		(search = '') => {
			navigate(`/tariffs${search}`, { state: { backgroundLocation: location } })
		},
		[navigate, location],
	)
}
